import { get, post } from '@eika-infrastruktur/request';
import type {
    ApproveCreateShareSavingsAccountForChildProcessPayload,
    CreateShareSavingsAccountForChildProcess,
    CreateShareSavingsAccountForChildProcessPayload,
} from '@generated-types';
import type { ProcessId } from '@types';
import { getApiUrl } from '../utils';

export const getProcess = (processId: ProcessId): Promise<CreateShareSavingsAccountForChildProcess> =>
    get(getApiUrl(`process/${processId}`));

export const createProcess = (
    payload: CreateShareSavingsAccountForChildProcessPayload,
): Promise<CreateShareSavingsAccountForChildProcess> => post(getApiUrl('process'), payload);

export const approveProcess = (
    payload: ApproveCreateShareSavingsAccountForChildProcessPayload,
): Promise<CreateShareSavingsAccountForChildProcess> => post(getApiUrl('process/approve'), payload);
